import React from 'react'

const LabStepHeader = ({current}) => {
  return (
    <div className="step-header">
      <div className={`step-item ${current >= 1 ? "active" : ""}`}>
        <div className="step-circle">{current > 1 ? "✓" : "1"}</div>
        <span>Lab & Diagnostics Profile</span>
      </div>

      <div className="step-line" />

      <div className={`step-item ${current >= 2 ? "active" : ""}`}>
        <div className="step-circle">{current > 2 ? "✓" : "2"}</div>
        <span>Accreditation & Compliance</span>
      </div>

      <div className="step-line" />

      <div className={`step-item ${current >= 3 ? "active" : ""}`}>
        <div className="step-circle">{current > 3 ? "✓" : "3"}</div>
        <span>Service & Catalog</span>
      </div>

      <div className="step-line" />

      <div className={`step-item ${current >= 4 ? "active" : ""}`}>
        <div className="step-circle">{current > 4 ? "✓" : "4"}</div>
        <span>Bank & Documents</span>
      </div>
    </div>
  )
}

export default LabStepHeader